<script setup lang="ts">
import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 24 24">
    <path
      d="M2.99059 3.99991C1.33896 3.99991 4.81711e-05 5.30807 4.81711e-05 6.92177L0 16.4828C0 18.0965 1.33891 19.4047 2.99054 19.4047L11.5049 19.4047L17.8664 22.9322C18.2562 23.105 18.7158 22.9362 18.8927 22.5552C19.0695 22.1742 18.8968 21.7252 18.5068 21.5524L11.8401 17.8896L2.99054 17.8896C2.19531 17.8896 1.55065 17.2598 1.55065 16.4828L1.5507 6.92177C1.5507 6.14481 2.19536 5.51495 2.99059 5.51495H21.0095C21.8046 5.51495 22.4493 6.14481 22.4493 6.92177L22.4493 16.4828C22.4493 17.2598 21.8046 17.8896 21.0094 17.8896H18.2562C17.828 17.8896 17.4809 18.2288 17.4809 18.6472C17.4809 19.0655 17.828 19.4047 18.2562 19.4047H21.0094C22.661 19.4047 24 18.0964 24 16.4828L24 6.92177C24 5.30807 22.661 3.99991 21.0095 3.99991H2.99059Z"
      fill="url(#paint0_linear_8698_8408)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.63201 16.5423C5.42505 16.9456 4.91059 17.1141 4.48404 16.9184C4.05749 16.7227 3.87931 16.2362 4.08627 15.8328L8.38432 7.4577C8.53149 7.1711 8.84226 6.99226 9.17907 7.00027C9.51588 7.0084 9.81661 7.20201 9.94816 7.49539L12.5868 13.3826C12.7717 13.7955 12.5675 14.2726 12.131 14.4476C11.6945 14.6225 11.1899 14.4295 11.0048 14.0167L9.10431 9.77613L5.63201 16.5423Z"
      fill="#F9A4CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5098 12.8872L14.8793 9.68017L14.202 10.9999C13.9951 11.4032 13.4807 11.5717 13.0542 11.376C12.6276 11.1803 12.4493 10.6938 12.6563 10.2904L14.1101 7.45768C14.254 7.17723 14.5548 6.99951 14.8845 7C15.2141 7.00062 15.5143 7.17946 15.6571 7.46039L19.915 15.8355C20.1206 16.2396 19.9404 16.7254 19.5131 16.9196C19.0858 17.114 18.5721 16.9436 18.3666 16.5395L17.3358 14.512H14.8307C14.3565 14.512 13.9716 14.1479 13.9716 13.6996C13.9716 13.2513 14.3565 12.8872 14.8307 12.8872H16.5098Z"
      fill="#F9A4CA"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8698_8408"
        x1="18.9613"
        y1="23.2439"
        x2="3.17022"
        y2="5.57278"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.126298" stop-color="#50ABED" />
        <stop offset="0.876666" stop-color="#F9A4CA" />
      </linearGradient>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
